export default __webpack_public_path__ + "static/media/noodles.c5f1cd6e.png";